import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';

@Component({
  selector: 'app-mat-table',
  templateUrl: './mat-table.component.html',
  styleUrls: ['./mat-table.component.scss'],
  standalone: false,
})
export class MatTableComponent implements OnInit, OnChanges, OnDestroy {
  @Input() tableData: object;
  dataSource: object[];
  headers: string[];
  columnDefs: string[];
  dataToDownload: string = '';
  noTableData: boolean = false;
  data = {
    // Required
    type: '', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '', //Required.  Unique page id
    itype: '', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };

  constructor(private _telemetryServices: TelemetryServices) {}

  ngOnInit() {
    // telemtry  API CALL and, send data

    this.data.type = 'mat-table component';
    this.data.subtype = 'mat-table ';
    this.data.pageid = '1';
    this.data.itype = 'AUTO';
    this.data.stageto = 'initial mat-table loading';
    if (this.data) {
      // this._telemetryServices.telemetryImpression(this.data);
    }

    this.assignTableData();
  }

  assignTableData() {
    // console.log(this.tableData);
    if (this.tableData != undefined) {
      if (
        this.tableData['ELEMENT_DATA'] == undefined ||
        this.tableData['ELEMENT_DATA'].length == 0 ||
        this.tableData['ELEMENT_DATA'][0]['type'] == 'Total'
      ) {
        this.noTableData = true;
      } else {
        this.noTableData = false;
        for (const data in this.tableData) {
          if (data === 'ELEMENT_DATA') {
            this.dataSource = this.tableData[data];
            //this.columnDefs = Object.keys(this.dataSource[0]);
          }
          if (data === 'headers') {
            this.headers = this.tableData[data].map((el, _i) => {
              if (el.includes('_')) {
                return el.replace(/_/g, ' ');
              } else {
                return el;
              }
            });

            // this.columnDefs = this.headers;
            this.columnDefs = this.tableData[data];
          }
        }
      }
    }
  }

  getCellData(data) {
    if (typeof data === 'object') {
      return data.count;
    } else if (typeof data === 'number') {
      return data;
    } else {
      return data;
    }
  }

  ngOnChanges() {
    this.assignTableData();
  }

  //downlaod table data
  downloadTableData(data, headers) {
    this.dataToDownload = '';
    const dataSourceLength = data.length;
    let rowData = '';
    for (let i = 0; i < dataSourceLength; i++) {
      let line = '';
      for (const key in data[i]) {
        if (line != '') {
          line = line + ',';
        }
        if (data[i][key].count >= 0) {
          line = line + data[i][key].count;
        } else {
          line = line + data[i][key];
        }
      }
      rowData = rowData + line + '\r\n';
    }

    // as of now; but based on api data, row data and column dat ashould be done
    this.dataToDownload = this.dataToDownload + headers.join(',') + '\r\n' + rowData;

    if (this.dataToDownload.split('\n').length - 1 >= 1) {
      const fileName = 'reports-' + new Date();
      const anchor = document.createElement('a');
      anchor.href = URL.createObjectURL(new Blob([this.dataToDownload], { type: 'text/csv' }));
      anchor.download = fileName + '.csv';
      // start download
      anchor.click();
    }
  }
  ngOnDestroy() {
    // telemtry end call

    this.data.type = 'mat-table component';
    this.data.subtype = 'mat-table cleanup stage/end of page';
    this.data.pageid = '1';
    this.data.itype = 'AUTO';
    this.data.stageto = 'destroy component,initial page';
    if (this.data) {
      // this._telemetryServices.telemetryEnd(this.data);
    }
  }
}
